/**
 * Created by prog2 on 25/10/2018.
 */

import castellano from './castellano';
import english from './english';
import français from './français';
import deutsch from './deutsch';

const messages = {
    Español: castellano,
    English: english,
    Français: français,
    Deutsch: deutsch
}

export default messages;



// WEBPACK FOOTER //
// ./src/data/i18n/i18n.js